import React, { useState } from 'react';
import styles from './AuditLog.module.scss';
import { Box, Typography, Paper, Divider, Button } from '@mui/material';
import { AuditLogEntry } from '../../data/auditLogData';

interface AuditLogProps {
  data: AuditLogEntry[];
}

const AuditLog: React.FC<AuditLogProps> = ({ data }) => {
    const [isVisible, setIsVisible] = useState(false);

  const handleToggle = () => {
    setIsVisible(prev => !prev);
  };
  return (
    <Box className={styles.auditLogs}>
      
      <Button variant="contained" className={styles.showButton} onClick={handleToggle} sx={{ mb: 2 }}>
        {isVisible ? 'Hide Audit Log' : 'Show Audit Log'}
      </Button>

      {isVisible && (
        <>
            <Typography variant="h6" className={styles.title}>
                Showing the audit information
            </Typography>
          {data.map((entry, index) => (
            <Paper key={index} className={styles.entry} elevation={1}>
              <Typography variant="body2" className={styles.email}>
                Edit by <strong>{entry.email}</strong>
              </Typography>

              <Box className={styles.row}>
                <Typography variant="body2">
                  <span className={styles.label}>Activity :</span> {entry.activity}
                </Typography>
                <Typography variant="body2">
                  <span className={styles.label}>Event :</span> {entry.event}
                </Typography>
                <Typography variant="body2" className={styles.time}>
                  Time : {entry.timestamp}
                </Typography>
              </Box>
            </Paper>
          ))}
        </>
      )}
    </Box>
  );
};

export default AuditLog;
